import {
  ActionIcon,
  Badge,
  Button,
  Drawer,
  Group,
  LoadingOverlay,
  Stack,
  Text,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React from "react";
import { FaBars, FaColumns, FaLayerGroup, FaTasks } from "react-icons/fa";
import CommandCenterV2 from "./v2/command_center";
import { useApp } from "../contexts/app.context";
import { useAuth } from "../contexts/auth.context";

export type LayoutV2Props = {
  children?: React.ReactNode;
};

const LayoutV2 = ({}: LayoutV2Props) => {
  const {
    logout,
    loading: loadingAuth,
  } = useAuth();
  const { loadingCustomers, configs } = useApp();
  const [opened, setOpened] = React.useState(false);
  const [activeView, setActiveView] = React.useState("command-center");
  const isMobile = useMediaQuery("(max-width: 992px)");

  const navbarContent = [
    { key: "command-center", title: "Command Center", icon: <FaColumns /> },
    { key: "pipeline", title: "Pipeline", icon: <FaTasks /> },
    { key: "workspace", title: "Workspace", icon: <FaLayerGroup /> },
  ];

  if (loadingAuth || loadingCustomers) {
    return <LoadingOverlay visible={true} />;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        background: "#f5f7fb",
        display: "flex",
      }}
    >
      {!isMobile && (
        <aside
          style={{
            width: 280,
            minHeight: "100vh",
            position: "fixed",
            top: 0,
            left: 0,
            background: configs?.brand || "#0f172a",
            color: "#ffffff",
            padding: 24,
            borderRight: "1px solid rgba(255,255,255,0.12)",
          }}
        >
          <Stack spacing="md" style={{ height: "100%" }}>
            <img
              alt={configs?.name ?? "AprovaAi"}
              src={configs?.image ?? "/logo-white.png"}
              style={{ height: 36, width: "fit-content" }}
            />
            <Stack spacing={8}>
              {navbarContent.map((item, index) => {
                const isActive = activeView === item.key;
                return (
                  <Button
                    key={`${item.key}-${index}`}
                    onClick={() => setActiveView(item.key)}
                    fullWidth
                    variant={isActive ? "white" : "subtle"}
                    color={isActive ? "dark" : "gray"}
                    leftIcon={item.icon}
                    style={{ justifyContent: "flex-start" }}
                  >
                    {item.title}
                  </Button>
                );
              })}
            </Stack>
            <Badge color="white" variant="filled" style={{ color: configs?.brand || "#0f172a", width: "fit-content" }}>
              V2 em paralelo
            </Badge>
            <div style={{ marginTop: "auto" }}>
              <Button fullWidth variant="outline" color="gray" onClick={logout}>
                Sair
              </Button>
            </div>
          </Stack>
        </aside>
      )}

      {isMobile && (
        <>
          <div
            style={{
              height: 72,
              width: "100%",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              zIndex: 10,
              background: configs?.brand || "#0f172a",
              padding: "16px",
            }}
          >
            <Group position="apart" align="center">
              <ActionIcon variant="filled" color="dark" onClick={() => setOpened(true)}>
                <FaBars />
              </ActionIcon>
              <img
                alt={configs?.name ?? "AprovaAi"}
                src={configs?.image ?? "/logo-white.png"}
                style={{ height: 30 }}
              />
              <div style={{ width: 32 }} />
            </Group>
          </div>

          <Drawer
            opened={opened}
            onClose={() => setOpened(false)}
            position="left"
            padding="md"
            size={280}
            title="Menu"
          >
            <Stack spacing={8}>
              {navbarContent.map((item, index) => {
                const isActive = activeView === item.key;
                return (
                  <Button
                    key={`${item.key}-mobile-${index}`}
                    onClick={() => {
                      setActiveView(item.key);
                      setOpened(false);
                    }}
                    fullWidth
                    variant={isActive ? "filled" : "light"}
                    color="dark"
                    leftIcon={item.icon}
                    style={{ justifyContent: "flex-start" }}
                  >
                    {item.title}
                  </Button>
                );
              })}
              <Button variant="outline" color="gray" onClick={logout}>
                Sair
              </Button>
            </Stack>
          </Drawer>
        </>
      )}

      <main
        style={{
          flex: 1,
          marginLeft: isMobile ? 0 : 280,
          marginTop: isMobile ? 72 : 0,
          padding: isMobile ? 16 : 32,
        }}
      >
        {activeView === "command-center" && <CommandCenterV2 />}
        {activeView !== "command-center" && (
          <div
            style={{
              minHeight: isMobile ? "calc(100vh - 104px)" : "calc(100vh - 64px)",
              border: "1px dashed #ccd5e4",
              borderRadius: 16,
              background: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text color="dimmed">Area reservada para modulos V2 (sem impacto no legado)</Text>
          </div>
        )}
      </main>
    </div>
  );
};

export default LayoutV2;